import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Badge, Form, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { toast } from "react-toastify";

import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";

import MyButton from "../../MyComp/UI/form/MyButton";
import MyInput from "../../MyComp/UI/form/MyInput";
import Status from "../../MyComp/UI/form/Status";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";

import {
  createLabCategory,
  createPromotion,
  deleteLabCategory,
  getLabCategory,
  getPromotionListAPI,
  updateLabCategory,
  updatePromotion,
} from "../../api/master/indes";
import OrderComponent from "../../MyComp/UI/form/OrderComponent";
import DeleteModal from "../../MyComp/UI/modals/DeleteModal";
import DateComponent from "../../MyComp/UI/form/DateComponent";
import DateIso from "../../MyComp/UI/form/DateIso";
import useLogout from "../../hooks/useLogout";
import MyDate from "../../MyComp/UI/form/MyDate";
import moment from "moment";
import MySelect from "../../MyComp/UI/form/MySelect";
import { categoryDDAPI } from "../../api/dropdown";

const Promotion = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      categoryDD: [],
    },
  });

  const { logout } = useLogout();

  // Separate table state from form
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const columns = [
    {
      name: "Code",
      selector: (row) => row?.code,
      sortable: true,
    },
    {
      name: "Type",
      selector: (row) => <>
        <span className="text-capitalize">{row?.discountType}</span>
      </>,
      sortable: true,

      width: "110px"
    },
    // {
    //   name: "Category",
    //   selector: (row) => (
    //     <>
    //       <div>
    //         {row?.categories?.map((item, index) => (
    //           <Badge color="outline-primary">{item?.label}</Badge>
    //         ))}
    //       </div>
    //     </>
    //   ),
    //   sortable: true,
    //   wrap: true,
    // },

    {
      name: "Discount",
      selector: (row) => row?.discountValue,
      sortable: true,
      width: "120px",
    },
    {
      name: "Start Date",
      selector: (row) => row?.startDate,
      sortable: true,
    },
    {
      name: "End Date",
      selector: (row) => row?.endDate,
      sortable: true,
    },
    {
      name: "Description",
      selector: (row) => row?.description,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge
            style={{ width: "57px", display: "flex", justifyContent: "center" }}
            color={row.status ? "success" : "danger"}
          >
            {row.status ? "Active" : "Inactive"}
          </Badge>
        </div>
      ),
      sortable: true,
      width: "90px",
    },
    {
      name: "Action",
      cell: (row) => (
        <div>
          <Button outline color="warning" size="xs" onClick={() => handleEdit(row)}>
            <Icon name="edit" />
          </Button>{" "}
          <Button outline color="danger" size="xs" onClick={() => handleDeleteClick(row)}>
            <Icon name="trash" onClick={() => handleDeleteClick(row)} />
          </Button>
        </div>
      ),

      width: "120px",
    },
    // {
    //   name: "Delete",
    //   width: "150px",
    //   cell: (row) => (
    //     <Button outline color="danger" size="xs" onClick={() => handleDeleteClick(row)}>
    //       <Icon name="trash" onClick={() => handleDeleteClick(row)} />
    //     </Button>
    //   ),
    // },
  ];

  useEffect(() => {
    if (watch("categoryDD")?.length < 1) {
      getCategory();
    }
    getPromotionList();
  }, []);
  const getCategory = () => {
    categoryDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("categoryDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("categoryDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  const getPromotionList = () => {
    setLoading(true);
    getPromotionListAPI()
      .then((res) => {
        setLoading(false);
        if (res.data.status === true) {
          setTableData(res.data.data);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const onFormSubmit = (formData) => {
    console.log(formData, "tabledata >>>   ");
    // return false;
    const a = watch("code")
    const body = {
      code: a.toUpperCase(),
      discount: Number(watch("discount")),

      min_amount: Number(watch("min_amount")),
      max_discount: Number(watch("max_discount")),
      type: watch("type")?.value,
      description: watch("description"),
      start_time: moment(formData?.start_date).format("MM/DD/yyyy h:mm A"),
      end_time: moment(formData?.exp_date).format("MM/DD/yyyy h:mm A"),
      // category_id: watch("category")?.map((item) => item.value),
      status: watch("status")?.value,

      ...(mode === "Edit" && { id: selectedRow?.id }),
    };
    console.log(body, "body");

    setLoading(true);

    const apiCall = mode === "Add" ? createPromotion(body) : updatePromotion(body);

    apiCall
      .then((res) => {
        setLoading(false);
        if (res.data.status === true) {
          toast.success(res.data.message);

          getPromotionList();

          setIsOpen(false);
          setMode("Add");
          reset();
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setSelectedRow(row);
    setIsOpen(true);
    setMode("Edit");
    // setValue("category", row?.categories);
    setValue("start_date", new Date(row.startDate));
    setValue("exp_date", new Date(row.endDate));
    setValue(
      "type",
      [
        { value: "percentage", label: "Percentage" },
        { value: "fixed", label: "Fixed" },
      ].find((item) => item?.value == row?.discountType)
    );
    setValue("value", row.discountValue);
    setValue("description", row.description);
    setValue("code", row.code);
    setValue("discount", row.discountValue);
    setValue("min_amount", row.minimum_purchase_amount);
    setValue("max_discount", row.maximum_discount_amount);
    setValue("order", row.order);
    setValue("status", {
      label: row.status ? "Active" : "Inactive",
      value: row.status,
    });
  };

  const handleToggleStatus = (row) => {
    console.log(row, "rowtoggle");
    setSelectedRow(row);
    setShowModal(true);
  };

  const confirmStatusChange = () => {
    // Determine the updated status explicitly based on current status
    const updatedStatus = !selectedRow.status;

    // Optionally show loading
    setLoading(true);

    updatePromotion({ id: selectedRow.id, status: updatedStatus })
      .then((res) => {
        setLoading(false);
        if (res.data.status === true) {
          toast.success(res.data.message);

          // Update local table only
          setTableData((prev) =>
            prev.map((item) =>
              item.id === selectedRow.id
                ? { ...item, status: updatedStatus }
                : item
            )
          );

          setShowModal(false);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const handleDeleteClick = (row) => {
    setSelectedRow(row);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    if (!selectedRow) return;

    setLoading(true);

    deleteLabCategory({ id: selectedRow.id })
      .then((res) => {
        setLoading(false);
        setShowDeleteModal(false);
        if (res.data.status === true) {
          toast.success(res.data.message);
          setTableData((prev) => prev.filter((item) => item.id !== selectedRow.id));
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  const resetF = () => {
    setValue("status", "");
    setValue("selectedRow", "");
    setMode("Add");
    setValue("discount", "");
    setValue("start_date", null);
    setValue("exp_date", null);
    setValue("type", "");
    setValue("coupon_name", "");
    setValue("code", "");
    setValue("category", "");
    setValue("description", "");
    setValue("min_amount", "");
    setValue("max_discount", "");
  };
  useEffect(() => {
    const a = watch("code");
    setValue("code", a?.toUpperCase())
  }, [watch("code")])
  return (
    <>
      <Head title="Laboratory | Master" />
      <Content>
        <BlockHead size="sm" className="mb-0 pb-0">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Promotion{" "}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <Button
                color="primary"
                outline
                className="me-n1"
                onClick={() => {
                  if (!isOpen) {
                    setIsOpen(true);
                    setMode("Add");
                    resetF();
                  } else {
                    setIsOpen(false);
                  }
                }}
              >
                <Icon name={isOpen ? "minus" : "plus"} />
              </Button>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block className="pt-0">
          {isOpen && (
            <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                  <Col md="3">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Code"
                      name="code"
                      placeholder="Enter code "
                      required
                    />
                  </Col>
                  <Col md={3}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Type"}
                      name={"type"}
                      placeholder={"Select type"}
                      required
                      options={[
                        { value: "percentage", label: "Percentage" },
                        { value: "fixed", label: "Fixed" },
                      ]}
                    />
                  </Col>

                  <Col md="3">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Discount"
                      name="discount"
                      placeholder="Enter discount"

                      max={watch("type")?.value == "percentage" ? 2 : 3}
                    />
                  </Col>
                  <Col md="3" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Minimum Amount"}
                      name={"min_amount"}
                      placeholder={"Enter minimum amount to avail coupon"}
                      required


                    />
                  </Col>
                  <Col md="3" className={`mt-2`}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Maximum Discount"}
                      name={"max_discount"}
                      placeholder={"Enter maximum discount to avail"}
                      required

                    />
                  </Col>
                  <Col md="3" className={`mt-2`}>
                    <MyDate
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Start Date"}
                      name={"start_date"}
                      placeholder={"Enter start date"}
                      required
                      min={moment().add(0, "days").toDate()}
                      max={moment().add(1, "years").toDate()}
                      time
                      format={"MM/dd/yyyy h:mm aa"}
                    />
                  </Col>
                  <Col md="3" className={`mt-2`}>
                    <MyDate
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Expiry Date"}
                      name={"exp_date"}
                      placeholder={"Enter expiry date"}
                      required
                      min={moment().add(1, "days").toDate()}
                      max={moment().add(1, "years").toDate()}
                      time
                      format={"MM/dd/yyyy h:mm aa"}
                    />
                  </Col>

                  {/* <Col md="3" className={`mt-2`}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Category"}
                      name={"category"}
                      placeholder={"Select category"}
                      required
                      options={watch("categoryDD")}
                      multi
                    />
                  </Col> */}
                  <Col md="3" className={`mt-2`}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Description"
                      name="description"
                      placeholder="Enter description"
                      required
                    />
                  </Col>
                  {/* <Col md="3">
                    <Status
                      register={register}
                      watch={watch}
                      title={"Status"}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                    />
                  </Col> */}
                </Row>{" "}
                <Col md="3">
                  <MyButton isLoading={loading} mode={mode} />
                </Col>
              </Form>
            </PreviewAltCard>
          )}

          <MyDataTable data={tableData} columns={columns} title="Promotion" isLoading={loading} />
        </Block>
      </Content>

      <DeleteModal
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
        confirmDelete={confirmDelete}
        selectedRow={selectedRow}
        loading={loading}
      />

      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={selectedRow?.status}
      />
    </>
  );
};

export default Promotion;
